import request from '@/utils/request';



export default {
    // 获取asl下拉列表
    getSelectorForAsl: (param) => {
        return request({
            url: `/rmc/protein/auditReport/getSelectorForAsl`,
            method: 'post',
            data:param
        });
    },
    // 第三方审核列表
    getAuditReportList: (param) => {
        return request({
            url: `/rmc/protein/auditReport/queryPage`,
            method: 'post',
            data:param
        });
    },
    // 提交
    submitAuditReport: (param) => {
        return request({
            url: `/rmc/protein/auditReport/submitAuditReport`,
            method: 'post',
            data:param
        });
    },
    // 详情页面
    queryDeatil: (ttRmcProteinAuditReportId) => {
        return request({
            url: `/rmc/protein/auditReport/queryDeatil/${ttRmcProteinAuditReportId}`,
            method: 'post',
        });
    },
    // 导出ASL审核报告
    exportAslAuditReport: (param) => {
        return request({
            url: `/rmc/protein/auditReport/exportAslAuditReport`,
            method: 'post',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 导出历史记录
    exportHistoryReport: (param) => {
        return request({
            url: `/rmc/protein/auditReport/exportHistoryReport`,
            method: 'post',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 审核报告下载
    downloadAuditReport: (param) => {
        return request({
            url: `/rmc/protein/auditReport/downloadAuditReport`,
            method: 'post',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 下拉框参数
    getSelector: (param) => {
        return request({
            url: `/rmc/protein/auditReport/getSelector`,
            method: 'post',
            data:param,
        });
    },
    // 消除待办
    completeTaskTodo: (ttQspiTodoId) => {
        return request({
            url: `/rmc/protein/auditReport/completeTaskTodo/${ttQspiTodoId}`,
            method: 'post',
        });
    },
    
}



